import { useSelector } from 'react-redux'

export const useEnsureInvitingCompanyId = (): string | undefined => {
  const companyProfileData = useSelector(
    (state: any) => state?.whiteLabel?.companyProfile
  )
  const companyId = companyProfileData?.fullData?.companyId

  // Return the reactive Redux value so callers get it on the first render (no timing race).
  // Falls back to localStorage for cases where the store isn't populated yet.
  if (companyId != null && companyId !== 0 && companyId !== '0') {
    return String(companyId)
  }
  const stored = localStorage.getItem('invitingCompanyId')
  return stored != null && stored !== '' && stored !== '0' ? stored : undefined
}
